import React, {useMemo, useCallback} from 'react';
import {GatewayGetSchema} from '../../../../../api/DBSchema/Gateway'
import Separator from '../../../../../components/Simple/Sepperator';
import PlanEditorInnerContainer from '../../../../../components/Editor/PlanEditorInnerContainer';
import {SMCSelect, SMCOption} from '../../../../../components/Simple/SMCSelect';
import EditorLayout from '../../../../../components/Layouts/EditorLayout';
import {useTranslation} from 'react-i18next';
import {TimezoneValues} from '../../../../../api/DBSchema/Timezone';
import {SMCToggleSwitch} from "../../../../../components/Simple/SMCToggleSwitch";

const pageSchema = GatewayGetSchema.pages.timezone;
const pageId = pageSchema.pageId;

function BaseTimezone({
    pageData,
    setObjectData,
    pageDisabled
}) {
    const { t } = useTranslation();

    const managedInSmp        = pageData[pageSchema.manageInSmp]
    const localTimeZone       = pageData[pageSchema.localTimeZone]
    const autoDaylightSavings = pageData[pageSchema.autoDaylightSavings]

    const timezoneOptions = useMemo(() => {

        return TimezoneValues.map((timezoneConf) => {
            return (
                <SMCOption key={timezoneConf['location']} value={timezoneConf['location']}>
                    {t(timezoneConf['i18n'])}
                </SMCOption>
            )
        });
    }, [t]);

    const setPageValue = useCallback((paramName, newValue) => {
        if (!pageDisabled) {
            setObjectData([pageId, paramName], newValue);
        }
    }, [setObjectData, pageDisabled]);

    return (
        <EditorLayout labelWidth={180}>
            <SMCToggleSwitch
                disabled={pageDisabled}
                checked={managedInSmp}
                onChange={checked => setPageValue(pageSchema.manageInSmp, checked)}
                label={t('SMP.PLAN.MANAGE_IN_SMP')}
            />
            <Separator isMainSeparator/>
            <PlanEditorInnerContainer title={t('SMP.PLANS.INNER_MENU.TIME_ZONE')} managedInSmp={managedInSmp}>
                <SMCSelect
                    disabled={pageDisabled || !managedInSmp}
                    value={localTimeZone}
                    onChange={e => setPageValue(pageSchema.localTimeZone, e.target.value)}
                    label={t('SMP.PLAN.NEW_PLAN_DS.TZ.LOCAL_TIME_ZONE')}
                    showEmptyOptionOnDisabled={true}
                >
                    {timezoneOptions}
                </SMCSelect>
                <SMCToggleSwitch
                    disabled={pageDisabled || !managedInSmp}
                    checked={autoDaylightSavings}
                    onChange={checked => setPageValue(pageSchema.autoDaylightSavings, checked)}
                    label={t('SMP.PLAN.NEW_PLAN_DS.TZ.LINE1')}
                />
            </PlanEditorInnerContainer>
        </EditorLayout>
    );
}

export default BaseTimezone;